var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"car-approval-record page-padding"},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }